// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"633":"1ad76a93","992":"1ab09658"}[chunkId] + ".css";
};